import React, {Component} from 'react';
import PropTypes from "prop-types";
import Select from 'react-select';
import StaticFunctions from "../../utils/StaticFunctions";

class SetupTimezones extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        timezones: PropTypes.array.isRequired,
    };

    constructor(props) {

        super(props);

        this.state = {
            currentTimezone: props.baseData.companies.currentCompany ? props.baseData.companies.currentCompany.timezone : '',
        };

        this.translate = this.props.baseData.translate;

        this.selectTimezone = this.selectTimezone.bind(this);

    }

    componentWillReceiveProps(nextProps) {

        this.setState({
            currentTimezone: nextProps.baseData.companies.currentCompany ? nextProps.baseData.companies.currentCompany.timezone : '',
        });

    }

    getTimezones() {

        return this.props.timezones.map((tz) => {
            const gmt = StaticFunctions.getGmtFromTimezoneString(tz);
            const label = tz + ((gmt) ? ' ' + gmt : '');

            return {
                label: label,
                value: tz
            }
        });

    }

    selectTimezone(event) {

        if (!event || !event.value) return;

        this.setState({
            currentTimezone: event.value
        });

        if (this.props.baseData.saveSettings) this.props.baseData.saveSettings('timezone', event.value);

    }

    render() {

        const timezones = this.getTimezones();

        return (
            <div className="formSettings">
                <nav>
                    <h1>{this.translate('setupHeader2')}</h1>
                </nav>

                <div>
                    <p>{this.translate('setupText2')}</p>
                </div>

                <div className="formRow">
                    <table>
                        <tbody>
                            <tr>
                                <td className="text-left labelSpan">{this.translate('timezone')}</td>

                                <td className="text-left">
                                    <Select
                                        name="form-field-name"
                                        className="chosen-container chosen-container-single"
                                        style={{width: '260px'}}
                                        options={timezones}
                                        onChange={this.selectTimezone}
                                        value={timezones.find(o => o.value === this.state.currentTimezone) || null}
                                        placeholder={this.translate('select') + '...'}
                                        clearable={false}
                                        noResultsText={this.translate('noResultsFound')}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );

    }

}

export default SetupTimezones;